import { Icon } from './Icon';

/** Egy ProjectFlow-feladat, amihez a hivas tartozik. */
export interface CallTask {
  title: string | null;
  url: string;
}

/**
 * A hivas uzenet-meta-jabol a feladat - ha van, es ervenyes.
 *
 * A meta kulso rendszertol (ProjectFlow) jovo adatot visz: csak http(s) cimet
 * fogadunk el, mert linkkent jelenik meg - egy `javascript:` cim kodot futtatna.
 */
export function taskFromMeta(value: unknown): CallTask | null {
  if (!value || typeof value !== 'object') return null;
  const { title, url } = value as { title?: unknown; url?: unknown };
  if (typeof url !== 'string' || !/^https?:\/\//i.test(url)) return null;
  return { title: typeof title === 'string' && title ? title : null, url };
}

/**
 * "Kapcsolódó feladat" link a hivasablakban es a nem fogadott hivas kartyajan.
 *
 * Uj lapon nyilik: a hivas kozben a hivasablak nem cserelodhet le.
 */
export function TaskLink({ task }: { task: CallTask }) {
  if (!/^https?:\/\//i.test(task.url)) return null;
  return (
    <a
      href={task.url}
      target="_blank"
      rel="noopener noreferrer"
      className="mt-0.5 inline-flex max-w-full items-center gap-1 truncate text-xs font-semibold text-accent hover:underline"
    >
      <Icon name="pipa" size="sm" />
      <span className="truncate">Feladat: {task.title ?? 'megnyitás a ProjectFlow-ban'}</span>
    </a>
  );
}
